export default __webpack_public_path__ + "static/hero-video-4a469efe6a435aa54a7688fddbef1b20.mp4";